import { render, staticRenderFns } from "./McpAuthorize.vue?vue&type=template&id=0ada7afb&scoped=true&"
import script from "./McpAuthorize.vue?vue&type=script&lang=js&"
export * from "./McpAuthorize.vue?vue&type=script&lang=js&"
import style0 from "./McpAuthorize.vue?vue&type=style&index=0&id=0ada7afb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ada7afb",
  null
  
)

export default component.exports